<script setup>
import { useDetectDevice } from '@/composables/device'

import ListingsView from '@/components/planner/ListingsView.vue'
import ListingsGrid from '@/components/planner/ListingsGrid.vue'

const { isMobile } = useDetectDevice()

</script>
<template>
  <listings-view v-if="isMobile" />
  <listings-grid v-else />
</template>
